// extracted by mini-css-extract-plugin
export default {"tx":"c7e555ab96","line":"a50e191008"};